module.exports = __webpack_public_path__ + "img/beer_id-52.8e51d77a.png";